export default "__VITE_ASSET__CBQTF1k$__"